import { useMutation } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

export type ReportPeriod = 'today' | 'days' | 'week' | 'sprint' | 'since-last';

/** Starts the session that writes a report over a period */
export function useStartReport(serverId: string) {
  const api = useApiClient();
  return useMutation({ mutationFn: (body: { period: ReportPeriod; days?: number }) => api.reports.start(serverId, body) });
}
